import {
  RESET_ZOOM_CREDENTIALS_SUCCESS,
  RESET_ZOOM_CREDENTIALS_FAIL,
  GET_ZOOM_AUTH_URL_SUCCESS,
  GET_ZOOM_AUTH_URL_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  authURL: "",
  error: {},
  loading: true,
  success: false,
}

const Zoom = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_ZOOM_CREDENTIALS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      }
    case RESET_ZOOM_CREDENTIALS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_ZOOM_AUTH_URL_SUCCESS:
      return {
        ...state,
        authURL: action.payload,
        loading: false,
      }
    case RESET_ZOOM_CREDENTIALS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default Zoom
